var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sq-footer" }, [
      _vm._v("\n  Made w/ love @ "),
      _c("a", { attrs: { target: "_blank", href: "https://sqreen.io" } }, [
        _vm._v("Sqreen"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }